import React, { FC, memo } from "react";

import { StyledContent } from "./styled";

const Loader: FC = () => <StyledContent />;

export default memo(Loader);
